import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/");
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        await api.post("/auth/session", { session_id }, { withCredentials: true });
        // Strip the session_id from the URL BEFORE calling refresh() —
        // otherwise AuthProvider's hash-guard bails out and the user state
        // never gets populated, which is what caused the "must hard-refresh
        // to see my name + admin features" bug.
        window.history.replaceState({}, "", "/");
        await refresh();
        toast.success("Signed in");
        navigate("/", { replace: true });
      } catch (e) {
        console.error("Sign-in failed", e);
        const detail = e?.response?.data?.detail;
        const status = e?.response?.status;
        const reason = detail
          ? `${detail}${status ? ` (HTTP ${status})` : ""}`
          : e?.message
            ? `Network error: ${e.message}`
            : "Unknown error";
        toast.error(`Sign-in failed — ${reason}`, { duration: 9000 });
        navigate("/");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <p className="text-sm text-slate-500">Signing you in…</p>
    </div>
  );
}
